/**
 * Product gallery: video slides.
 * Works with assets/clz.js (slides are [data-clz-slide], the active one has .is-on).
 * - A video file plays muted and loops while its slide is shown, and pauses when the slide is left.
 * - A YouTube or Vimeo slide loads its player only when shown, and unloads it when left (so it stops playing).
 * - While a video slide is shown, the gallery stops sliding by itself, so the video is never cut off.
 */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setup(main) {
    if (!main || main.__clzMedia) return;
    main.__clzMedia = true;
    var slides = [].slice.call(main.querySelectorAll('[data-clz-slide]'));
    var holding = false;

    function fire(type) { main.dispatchEvent(new MouseEvent(type)); }

    function sync() {
      var onVideo = false;
      slides.forEach(function (s) {
        var on = s.classList.contains('is-on');
        var v = s.querySelector('video');
        var f = s.querySelector('iframe[data-src]');
        if (v) {
          if (on) {
            onVideo = true;
            if (!reduce) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
          } else { v.pause(); }
        }
        if (f) {
          if (on) {
            onVideo = true;
            if (!f.getAttribute('src')) f.setAttribute('src', f.getAttribute('data-src'));
          } else if (f.getAttribute('src')) { f.removeAttribute('src'); }
        }
      });
      if (onVideo && !holding) { holding = true; fire('mouseenter'); }
      else if (!onVideo && holding) { holding = false; fire('mouseleave'); }
    }

    var mo = new MutationObserver(sync);
    slides.forEach(function (s) { mo.observe(s, { attributes: true, attributeFilter: ['class'] }); });
    sync();
  }

  function init(scope) {
    [].slice.call((scope || document).querySelectorAll('[data-clz-main]')).forEach(setup);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
